/* oxlint-disable typescript/no-deprecated */
import type { TruncationMode } from '../../../typography/text-ellipsis/TextEllipsis.js';

/**
 * @deprecated Use `truncateString` from `core/components/text-ellipsis/truncate-string` instead.
 * can be removed APPDEV-15421
 * @internal
 */
export const truncateText = (
  text: string,
  truncationMode: TruncationMode,
  stopTruncation: (text: string) => boolean,
) => {
  let truncatedText = text;

  while (!stopTruncation(truncatedText)) {
    const filteredText = truncatedText.replace(/\.\.\./, '');

    if (!filteredText.length) {
      break;
    }

    truncatedText = TRUNCATE_LABEL[truncationMode](filteredText);
  }

  return truncatedText;
};

/**
 * @deprecated Use the ellipsis character from `typography/utils` instead.
 * can be removed APPDEV-15421
 * @internal
 */
export const ELLIPSIS = '...';

/**
 * @deprecated Use `truncateString` from `core/components/text-ellipsis/truncate-string` instead.
 * can be removed APPDEV-15421
 * @internal
 */
export const middleTruncation = (text: string) => {
  const middle = Math.floor(text.length / 2);
  const firstHalf = text.slice(0, middle);
  const secondHalf = text.slice(middle + 1);

  const hasEllipsis = firstHalf.length || secondHalf.length;

  const newText = `${firstHalf}${hasEllipsis ? ELLIPSIS : ''}${secondHalf}`;

  return newText;
};

/**
 * @deprecated Use `truncateString` from `core/components/text-ellipsis/truncate-string` instead.
 * can be removed APPDEV-15421
 * @internal
 */
export const startTruncation = (text: string) => {
  const slicedText = text.slice(1);
  const hasEllipsis = slicedText.length;

  const newText = `${hasEllipsis ? ELLIPSIS : ''}${slicedText}`;

  return newText;
};

/**
 * @deprecated Use `truncateString` from `core/components/text-ellipsis/truncate-string` instead.
 * can be removed APPDEV-15421
 * @internal
 */
export const endTruncation = (text: string) => {
  const slicedText = text.slice(0, -1);
  const hasEllipsis = slicedText.length;

  const newText = `${text.slice(0, -1)}${hasEllipsis ? ELLIPSIS : ''}`;

  return newText;
};

/**
 * @deprecated Use `truncateString` from `core/components/text-ellipsis/truncate-string` instead.
 * can be removed APPDEV-15421
 * @internal
 */
export const TRUNCATE_LABEL: Record<TruncationMode, (text: string) => string> =
  {
    start: startTruncation,
    end: endTruncation,
    middle: middleTruncation,
  };
